<template>
    <div>
        <b-row>
            <b-col xl="6" sm="12">
                <div class="card">
                    <span style="" class="badge bg-danger rounded-pill badge-header">{{notification_count}}</span>
                    <div style="width:fit-content; color: #ffffff;" class="card-title card ccb_green p-2">Notices</div>
                    <div style="display: inline-flex;">
                        <div
                        :title="notification.name"
                        class="m-1 p-1 info-tile"
                        style="text-align: center; position: relative;"
                        :class="notification.length == 0 ? 'no-notification' : ''"
                        @click="selectNotification(notification, idx)"
                        v-for="(notification, idx) in notification_data" :key="notification.id">
                            <span style="" class="badge bg-danger rounded-pill notification_count">{{notification.length}}</span>
                            <!--<span style="text-align: center; display: absolute; float: right;">{{notification.length}}</span>-->
                            <div :class="selectedNotificationIndex == idx ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                                <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
                            </div>
                            <div>
                                <p class="text-capitalize text-truncate">{{notification.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="showNotifications == false">
            <b-col>
                <b-card :title="returnGroupName" v-if="hasSopGroupSelected">
                    <b-row>
                        <b-col cols="12" class="ps-3 pe-3" style="display: flex;">
                            <b-button variant="success" class="me-1">
                                <i class="fas fa-search"></i>
                            </b-button>
                            <b-button v-if="search_text !== ''" @click="search_text = ''" variant="warning" class="me-1">
                                <i class="fas fa-times"></i>
                            </b-button>
                            <b-form-input v-model="search_text" style="width: 50rem;"></b-form-input>
                        </b-col>
                    </b-row>

                    <b-overlay :show="show_overlay">
                        <div>
                            <span style="display: inline-flex; flex-wrap: wrap;">
                                <div
                                @contextmenu.prevent="clicker($event, doc.id)"
                                @click="selectedDocument(doc.id)"
                                :title="doc.name"
                                :id="'doc'+doc.id"
                                class="document-tile"
                                v-for="doc in documents" :key="doc.id">
                                    <SopCard :name="doc.name" :code="doc.sop_code" />
                                </div>
                            </span>
                        </div>
                        <b-alert :show="documents.length == 0">No Documents </b-alert>
                    </b-overlay>
                </b-card>
                <b-card v-else>
                    <b-alert show>
                        Select a SOP group
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="showNotifications">
            <b-col cols="12" >
                <b-card>
                    <NotificationsTable 
                        @back="clearSelectedNotification"
                        :group_notifications="selectedNotification"
                        :index="selectedNotificationIndex"
                        @selectedDocument="openDocumentFromNotification"
                        
                    />
                </b-card>
            </b-col>
        </b-row>
        <div @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextPopper" id="poptest" v-show="showPopper">
            <ContextMenu :view_type="'client'" @action="actionHandler" @close="hidePopper"/>
        </div>
    </div>
</template>

<script>
//import Swal from "sweetalert2";
import { createPopper } from '@popperjs/core';
import ContextMenu from "@/components/widgets/contextDocuments";
import _ from 'lodash'
import { sopMethods, sopState} from '@/state/helpers'
import NotificationsTable from '@/components/client/sop/notificationsTable.vue'
import SopCard from '@/components/widgets/misc/sopCard.vue'
export default {
    data:() => ({
        search_text: '',
        show_overlay: false,
        showPopper: false,
        popper_id: null,
        showNotifications: false,
        selectedNotification: null,
        selectedNotificationIndex: null,
        is_actionable_view: false,
    }),
    watch:{
        //TODO - This has been replaced in the tree menu
        /*selected_sop_group(newVal, oldVal){
            if(newVal !== oldVal && newVal != null){
                this.loadSops(this.selected_sop_group);
            }
        }*/
    },
    components:{
        ContextMenu,
        NotificationsTable,
        SopCard
    },
    computed:{
        ...sopState,
        documents(){
            if(this.selected_sop_group == null){
                return [];
            }
            else{
                if(this.search_text === ''){
                    let group = this.sop_groups.find( group => {
                        return group.id == this.selected_sop_group;
                    })
                    if(group){
                        return group.sops;
                    }
                    else{ return [];}
                }
                else{
                    let data = [];
                    let group = this.sop_groups.find( group => {
                        return group.id == this.selected_sop_group;
                    })
                    if(group){
                        data = _.cloneDeep(group.sops);
                    }
                    //let data = _.cloneDeep(this.sops.sop_types);
                    data = _.filter(data, function(o){
                        let valid = false;
                        let doc_name = o.name.toLowerCase();
                        let doc_code = o.sop_code.toLowerCase();
                        let text = window.inst.search_text.toLowerCase()
                        if(doc_name.includes(text) || doc_code.includes(text)){
                            valid = true;
                        }
                        return valid;
                    });
                    return data;
                }
                //return this.sops.sop_types;
            }
        },
        // documents(){
        //     if(this.sops == null){
        //         return [];
        //     }
        //     else{
        //         if(this.search_text === ''){
        //             return this.sops.sop_types;
        //         }
        //         else{
        //             let data = _.cloneDeep(this.sops.sop_types);
        //             data = _.filter(data, function(o){
        //                 let valid = false;
        //                 let doc_name = o.name.toLowerCase();
        //                 let doc_code = o.sop_code.toLowerCase();
        //                 let text = window.inst.search_text.toLowerCase()
        //                 if(doc_name.includes(text) || doc_code.includes(text)){
        //                     valid = true;
        //                 }
        //                 return valid;
        //             });
        //             return data;
        //         }
        //     }
        // },
        notification_count(){
            let count = 0;
            this.notification_data.forEach( notification_group => {
                count += notification_group.length;
            })
            return count;
        },
        notification_data(){
            let data = [];
            if(this.notifications != null){
                for (const key of Object.keys(this.notifications)) {
                    let item = {
                        name: _.replace(key, '_alerts', ''),
                        length: this.notifications[key].length,
                        icon: this.getIconType(key)
                    }
                    data.push(item);
                }
            }
            console.log(data);
            return data;
        },
        hasSopGroupSelected(){
            if(this.selected_sop_group == null){
                return false;
            }
            else{
                return true;
            }
        },
        returnGroupName(){
            let name = '';
            let index = _.findIndex(this.sop_groups, {id: this.selected_sop_group});
            if(index != -1){
                name = this.sop_groups[index].name;
            }
            return name;
        },
    },
    methods:{
        ...sopMethods,
        selectedDocument(id){
            this.showNotifications = false;
            this.clearSopStore();
            this.show_overlay = true;
            this.loadSopData(id)
            .then(()=>{
                this.$emit('edit', id);
                this.show_overlay = false;
                /*
                console.log('SOP DATA: ',this.sop_data)
                let index = _.findIndex(this.sop_data.client_revisions, { published: 1 });
                if(index != -1){
                    let revision_id = this.sop_data.client_revisions[index].client_revision_id;
                    this.previewSop({client_revision_id: revision_id})
                    .then( response => {
                        console.log('Response preview', response);
                    })
                }
                else{
                    alert('This SOP has no published revisions.');
                }*/
            })
            .catch((e)=>{
                console.log(e);
                this.show_overlay = false;
            })
        },
        clearSelectedNotification(){
            this.is_actionable_view = false;
            this.showNotifications = false;
            this.selectedNotification = null;
            this.selectedNotificationIndex = null;
        },
        openDocumentFromNotification(payload){
            this.setActionItemID(payload.action_id)
            let index = _.findIndex(this.sop_groups, {id: payload.group_id});
            if(index != -1){
                this.selectSopGroup(payload.group_id)
                .then(()=>{
                    this.selectedDocument(payload.id);
                    this.is_actionable_view = true;
                })
            }
        },

        //* misc ---------- 
        getIconType(key){
            if(key === 'document_alerts'){
                return 'fa-file'
            }
            if(key === 'facility_alerts'){
                return 'fa-building'
            }
            if(key === 'training_alerts'){
                return 'fa-people-carry'
            }
            if(key === 'action_alerts'){
                return 'fa-bell'
            }
        },

        selectNotification(notification, index){
            console.log('Notification group ' + index);
            let key = notification.name + '_alerts'
            this.selectedNotification = this.notifications[key];
            this.selectedNotificationIndex = index;
            this.showNotifications = true;
            /*let payload = {
                notification: notification,
                index: index
            }
            this.$emit('showNotifications', payload);*/
        },


        //* popper.js stuff
        hidePopper(){
            if(this.debug != null){
                this.debug.destroy();
            }
            this.showPopper = false;
        },
        actionHandler(type){
            //* set document id for the component that is about to be displayed
            this.setContextMenuID(this.popper_id);

            //* handle action
            switch(type){
                case 'stats':{
                    this.$emit('showStats')
                    break;
                }
                case 'edit':{
                    break;

                }
                default:{
                    break;
                }
            }
        },
        //eslint-disable-next-line
        clicker(event, id){
            //set id of right clicked document
            this.popper_id = id;
            this.hidePopper();
            this.$nextTick(()=>{
                this.showPopper = true;
                const doc = document.querySelector('#doc'+id)
                const popper = document.querySelector('#poptest')
                this.$nextTick(()=>{
                    this.debug = createPopper(doc, popper,{
                        placement: 'auto'
                    });
                    setTimeout(()=>{
                        if(this.$refs.contextPopper != undefined){
                            this.$refs.contextPopper.focus();
                        }
                    }, 250);
                })
            })
        },
    },
    mounted(){
        window.inst = this;
        if(this.notifications == null){
            this.loadNotifications();
        }
    },
    beforeDestroy(){
        window.inst = undefined;
    }
}
</script>

<style>
.document-add-tile{
    cursor: pointer;
    width: 8rem;
    height: 5rem;
    border: 2px solid var(--bs-success);
    border-radius: 0.25rem;
    transition: all 0.2s linear;
}
.document-add-tile:hover{
    color:var(--bs-success);
    transition: all 0.2s linear;
}

</style>